// extracted by mini-css-extract-plugin
export default {"page":"InfoPage_page_Cn4Uc","details":"InfoPage_details_zKrbc","main":"InfoPage_main_Mwxbt"};